import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectSiteComponent } from '../../shared/components/forms/input/select-site/select-site.component';
import { SelectCustomerComponent } from '../../shared/components/forms/input/select-customer/select-customer.component';
import { SharedModule } from './shared.module';
import { CurrencyInputComponent } from '../components/forms/input/currency/currency.component';
import { NewTextInputComponent, TextInputComponent } from '../components/forms/input/text/text.component';
import { GeolocationComponent } from '../components/forms/input/geolocation/geolocation.component';
import { GoogleMapComponent } from '../components/forms/input/geolocation/google-map/google-map.component';
import { AgmCoreModule } from '@agm/core';
import { EmailAddressInputComponent } from '../components/forms/input/email-address/email-address.component';
import { RelateInputComponent } from '../components/forms/input/relate/relate-input.component';
import { MultitextInputComponent } from '../components/forms/input/multitext/multitext-input.component';
import { DecimalInputComponent } from '../components/forms/input/decimal/decimal.component';
import { CheckboxInputComponent } from '../components/forms/input/checkbox/checkbox.component';
import { TextareaInputComponent } from '../components/forms/input/textarea/textarea.component';
import { DropdownInputComponent } from '../components/forms/input/dropdown/dropdown.component';
import { ChipsInputComponent } from '../components/forms/input/chips/chips.component';
import { NumberInputComponent } from '../components/forms/input/number/number.component';
import { QuillModule } from 'ngx-quill';
import { UploadFileInputComponent } from '../components/forms/input/upload-file/upload-file-input.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ColorPickerInputComponent } from '../components/forms/input/color-picker/color-picker-input.component';
import { IntervalInputComponent } from '../components/forms/input/interval/interval-input.component';
import { NotesComponent } from '../../features/new-scheduler/dialogs/notes/notes.component';
import { CalendarInputComponent } from '../components/forms/input/calendar/calendar-input.component';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { FieldmagicRelatedFieldComponent } from '../components/forms/input/related-field/related-field.component';
import { SmsService } from '../../services/sms.service';
import { AddressLocationInput } from '../components/forms/input/address/location-input.component';
import { WithinRadiusInputComponent } from '../components/forms/input/geolocation/within-radius-input.component';
import { DirectivesModule } from './directives.module';
import {
  FieldmagicDataGridCheckboxCellInputComponent,
  FieldmagicDataGridDateTimeCellInputComponent,
  FieldmagicDataGridDropdownCellInputComponent,
  FieldmagicDataGridRelateDropdownCellInputComponent,
  FieldmagicDataGridTextareaCellInputComponent,
} from '../components/data-grid/data-grid-inputs.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AgmCoreModule,
    QuillModule,
    ColorPickerModule,
    OwlDateTimeModule,
    DirectivesModule,
    FormsModule,
    NgSelectModule,
  ],
  declarations: [
    SelectSiteComponent,
    SelectCustomerComponent,
    CurrencyInputComponent,
    TextInputComponent,
    GeolocationComponent,
    GoogleMapComponent,
    EmailAddressInputComponent,
    RelateInputComponent,
    MultitextInputComponent,
    DecimalInputComponent,
    CheckboxInputComponent,
    TextareaInputComponent,
    NewTextInputComponent,
    DropdownInputComponent,
    NumberInputComponent,
    ChipsInputComponent,
    UploadFileInputComponent,
    ColorPickerInputComponent,
    IntervalInputComponent,
    NotesComponent,
    CalendarInputComponent,
    FieldmagicRelatedFieldComponent,
    AddressLocationInput,
    WithinRadiusInputComponent,
    FieldmagicDataGridDropdownCellInputComponent,
    FieldmagicDataGridRelateDropdownCellInputComponent,
    FieldmagicDataGridCheckboxCellInputComponent,
    FieldmagicDataGridDateTimeCellInputComponent,
    FieldmagicDataGridTextareaCellInputComponent,
  ],
  exports: [
    SelectSiteComponent,
    SelectCustomerComponent,
    CurrencyInputComponent,
    TextInputComponent,
    GeolocationComponent,
    GoogleMapComponent,
    EmailAddressInputComponent,
    RelateInputComponent,
    MultitextInputComponent,
    DecimalInputComponent,
    CheckboxInputComponent,
    TextareaInputComponent,
    NewTextInputComponent,
    DropdownInputComponent,
    NumberInputComponent,
    ChipsInputComponent,
    UploadFileInputComponent,
    ColorPickerInputComponent,
    IntervalInputComponent,
    CalendarInputComponent,
    FieldmagicRelatedFieldComponent,
    AddressLocationInput,
    WithinRadiusInputComponent,
    FieldmagicDataGridDropdownCellInputComponent,
    FieldmagicDataGridRelateDropdownCellInputComponent,
    FieldmagicDataGridCheckboxCellInputComponent,
    FieldmagicDataGridDateTimeCellInputComponent,
    FieldmagicDataGridTextareaCellInputComponent,
  ],
  entryComponents: [
    GoogleMapComponent,
    NotesComponent,
    FieldmagicDataGridDropdownCellInputComponent,
    FieldmagicDataGridRelateDropdownCellInputComponent,
    FieldmagicDataGridCheckboxCellInputComponent,
    FieldmagicDataGridDateTimeCellInputComponent,
    FieldmagicDataGridTextareaCellInputComponent,
  ],
  providers: [
    SmsService
  ],
})
export class SharedInputModule { }
